// import intl from 'react-intl-universal';
import NCCloudIntl from '../../public/nccloud-intl-universal';
import axios from 'axios';
import { localeLang } from '../../public/currentLocale';
import { getMultiLang } from '../../api/getMultiLang';
import ViewModel from '../../shell/viewmodel/viewmodel';
export {
    getMultiLang,
    getMultiLang as getPlatformLang
}
/*
export function getMultiLang({
                                 currentLocale,
                                 environment,
                                 getUrl,
                                 moduleId,
                                 callback,
                                 domainName = 'platform',
                                 needInlt = true,
                                 dataSource
                             }) {
    let intl = new NCCloudIntl();
    if (getUrl) {
        return axios.get(getUrl).then((res) => {
            callback && callback(res.data);
        });
    }

    async function setIntl(locale, res, callb) {
        let ins = await new Promise((resolve, reject) => {
            if (needInlt) {
                intl.init({
                    currentLocale: locale, // TODO: determine locale here
                    locales: {
                        [locale]: res
                    }
                });
                resolve(intl);
            } else {
                resolve(null);
            }
        });
        return callb(res, true, ins);
    }

    // let env = 'development';
    let env = 'production';

    if (window.parent && window.top.environmentmodel) {
        env = window.top.environmentmodel;
    }
    let bool = domainName === 'workbench' && environment === 'development';
    let domain = bool ? '' : domainName;
    let prefix = bool ? '' : env == 'development' ? '/src/' : '../../../../';
    let suffix = `/public/lang/standard/${localeLang}/`;
    let urls = [];
    if (typeof moduleId === 'number' || typeof moduleId === 'string') {
        urls.push(prefix + `${domain}` + suffix + moduleId + '.json');
    } else if (Array.isArray(moduleId)) {
        moduleId.map((item) => {
            urls.push(prefix + `${domain}` + suffix + item + '.json');
        });
    } else {
        for (let [ key, value ] of Object.entries(moduleId)) {
            if (Array.isArray(value)) {
                value.map((item) => {
                    urls.push(prefix + key + suffix + item + '.json');
                });
            } else {
                urls.push(prefix + key + suffix + value + '.json');
            }
        }
    }
    let tasks = urls.reduce((total, nowItem) => {
        total.push(axios.get(nowItem));
        return total;
    }, []);
    Promise.all(tasks)
        .then((res) => {
            let result = res.reduce((total, nowItem) => {
                return (total = { ...total, ...nowItem.data });
            }, {});
            setIntl(localeLang, result, callback);
        })
        .catch((err) => {
            callback({}, false);
        });
}

export function getPlatformLang({
                                    currentLocale,
                                    getUrl,
                                    moduleId,
                                    callback,
                                    domainName = 'platform',
                                    needInlt = true,
                                    dataSource
                                }) {
    let intl = new NCCloudIntl();
    let cache = ViewModel.getData(moduleId);
    if (getUrl) {
        return axios.get(getUrl).then((res) => {
            callback && callback(res.data);
        });
    }

    async function setIntl(locale, res, callb) {
        let ins = await new Promise((resolve, reject) => {
            if (needInlt) {
                intl.init({
                    currentLocale: locale, // TODO: determine locale here
                    locales: {
                        [locale]: res
                    }
                });
                // for (let item in intl.options) {
                //     console.log(item, intl.options[item])
                // }
                resolve(intl);
            } else {
                resolve(null);
            }
        });
        return callb(res, true, ins);
    }

    if (cache) {
        setIntl(localeLang, cache, callback);
    } else {
        let prefix = '../../../../';
        let suffix = `/public/lang/standard/${localeLang}/`;
        let urls = [];
        if (typeof moduleId === 'number' || typeof moduleId === 'string') {
            urls.push(prefix + domainName + suffix + moduleId + '.json');
        } else if (Array.isArray(moduleId)) {
            moduleId.map((item) => {
                urls.push(prefix + domainName + suffix + item + '.json');
            });
        } else {
            for (let [ key, value ] of Object.entries(moduleId)) {
                if (Array.isArray(value)) {
                    value.map((item) => {
                        urls.push(prefix + key + suffix + item + '.json');
                    });
                } else {
                    urls.push(prefix + key + suffix + value + '.json');
                }
            }
        }
        let tasks = urls.reduce((total, nowItem) => {
            total.push(axios.get(nowItem));
            return total;
        }, []);
        Promise.all(tasks).then((res) => {
            let result = res.reduce((total, nowItem) => {
                return (total = { ...total, ...nowItem.data });
            }, {});
            ViewModel.setData(moduleId, result);
            setIntl(localeLang, result, callback);
        });
    }
}
*/
